"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _index.Button;
  }
});
Object.defineProperty(exports, "IButton", {
  enumerable: true,
  get: function get() {
    return _index.IButton;
  }
});
Object.defineProperty(exports, "IIcon", {
  enumerable: true,
  get: function get() {
    return _index2.IIcon;
  }
});
Object.defineProperty(exports, "IImage", {
  enumerable: true,
  get: function get() {
    return _index3.IImage;
  }
});
Object.defineProperty(exports, "IInput", {
  enumerable: true,
  get: function get() {
    return _index4.IInput;
  }
});
Object.defineProperty(exports, "IInputDate", {
  enumerable: true,
  get: function get() {
    return _index5.IInputDate;
  }
});
Object.defineProperty(exports, "ILabel", {
  enumerable: true,
  get: function get() {
    return _index6.ILabel;
  }
});
Object.defineProperty(exports, "ILoader", {
  enumerable: true,
  get: function get() {
    return _index7.ILoader;
  }
});
Object.defineProperty(exports, "ILogo", {
  enumerable: true,
  get: function get() {
    return _index8.ILogo;
  }
});
Object.defineProperty(exports, "IParagraph", {
  enumerable: true,
  get: function get() {
    return _index9.IParagraph;
  }
});
Object.defineProperty(exports, "ISwitcher", {
  enumerable: true,
  get: function get() {
    return _index10.ISwitcher;
  }
});
Object.defineProperty(exports, "ITextArea", {
  enumerable: true,
  get: function get() {
    return _index11.ITextArea;
  }
});
Object.defineProperty(exports, "ITitle", {
  enumerable: true,
  get: function get() {
    return _index12.ITitle;
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _index2.Icon;
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _index3.Image;
  }
});
Object.defineProperty(exports, "Input", {
  enumerable: true,
  get: function get() {
    return _index4.Input;
  }
});
Object.defineProperty(exports, "InputDate", {
  enumerable: true,
  get: function get() {
    return _index5.InputDate;
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _index6.Label;
  }
});
Object.defineProperty(exports, "Loader", {
  enumerable: true,
  get: function get() {
    return _index7.Loader;
  }
});
Object.defineProperty(exports, "Logo", {
  enumerable: true,
  get: function get() {
    return _index8.Logo;
  }
});
Object.defineProperty(exports, "Paragraph", {
  enumerable: true,
  get: function get() {
    return _index9.Paragraph;
  }
});
Object.defineProperty(exports, "Switcher", {
  enumerable: true,
  get: function get() {
    return _index10.Switcher;
  }
});
Object.defineProperty(exports, "Textarea", {
  enumerable: true,
  get: function get() {
    return _index11.Textarea;
  }
});
Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _index12.Title;
  }
});

var _index = require("./Button/index");

var _index2 = require("./Icon/index");

var _index3 = require("./Image/index");

var _index4 = require("./Input/index");

var _index5 = require("./InputDate/index");

var _index6 = require("./Label/index");

var _index7 = require("./Loader/index");

var _index8 = require("./Logo/index");

var _index9 = require("./Paragraph/index");

var _index10 = require("./Switcher/index");

var _index11 = require("./Textarea/index");

var _index12 = require("./Title/index");